import { useEffect, useState } from "react";
import axios from "../../../../../api/axios";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";

import "./helpAndSupport.css";


const HelpAndSupport = () => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const businessGroupEntityId = userData?.businessEntityId;

    const [issueTypes, setIssueTypes] = useState([]);
    const [issues, setIssues] = useState([]);

    const [issueType, setIssueType] = useState("");
    const [description, setDescription] = useState("");

    const [isLoadingIssueTypes, setIsLoadingIssueTypes] = useState(false);
    const [isLoadingIssues, setIsLoadingIssues] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [error, setError] = useState("");

    const getIssueType = async () => {
        try {
            return await axios.get(
                `/support/issue-types/`
            );
        } catch (error) {
            console.error("Error fetching issue types:", error);
            return null;
        }
    };

    const getIssues = async ({ businessGroupEntityId }) => {
        try {
            return await axios.get(
                `/support/issues/${businessGroupEntityId}`
            );
        } catch (error) {
            console.error("Error fetching issues:", error);
            return null;
        }
    };

    const sendIssue = async ({ businessGroupEntityId, payload }) => {
        try {
            return await axios.post(
                `/support/issues/${businessGroupEntityId}`,
                payload
            );
        } catch (error) {
            console.error("Error sending issue:", error);
            return null;
        }
    };

    const fetchIssueTypes = async () => {
        setIsLoadingIssueTypes(true);
        setError("");

        const response = await getIssueType();

        if (!response) {
            setError("Unable to fetch issue types.");
            setIsLoadingIssueTypes(false);
            return;
        }

        setIssueTypes(response.data?.data || response.data || []);
        setIsLoadingIssueTypes(false);
    };

    const fetchIssues = async () => {
        if (!businessGroupEntityId) return;

        setIsLoadingIssues(true);
        setError("");

        const response = await getIssues({
            businessGroupEntityId,
        });

        if (!response) {
            setError("Unable to fetch issues.");
            setIsLoadingIssues(false);
            return;
        }

        setIssues(response.data?.data || response.data || []);
        setIsLoadingIssues(false);
    };

    const handleSubmitIssue = async (e) => {
        e.preventDefault();

        if (!businessGroupEntityId) {
            setError("Business group id is missing.");
            return;
        }

        if (!issueType) {
            setError("Please select an issue type.");
            return;
        }

        if (!description.trim()) {
            setError("Please enter issue description.");
            return;
        }

        setIsSubmitting(true);
        setError("");

        const response = await sendIssue({
            businessGroupEntityId,
            payload: {
                issueType: Number(issueType),
                description: description.trim(),
            },
        });

        if (!response) {
            setError("Unable to send issue.");
            setIsSubmitting(false);
            return;
        }

        setIssueType("");
        setDescription("");
        setIsSubmitting(false);

        fetchIssues();
    };

    useEffect(() => {
        fetchIssueTypes();
        fetchIssues();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [businessGroupEntityId]);

    return (
        <div className="home">
            <Sidebar />

            <div className="homeContainer">
                <Navbar />

                <div className="help-support-page">
                    <div className="help-support-header">
                        <h2>Help And Support</h2>
                        <p>Create support tickets and track your previous issues.</p>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <div className="help-support-content">
                        <div className="support-card">
                            <h3>Create New Issue</h3>

                            <form onSubmit={handleSubmitIssue}>
                                <div className="form-group">
                                    <label>Issue Type</label>

                                    <select
                                        value={issueType}
                                        onChange={(e) => setIssueType(e.target.value)}
                                        disabled={isLoadingIssueTypes}
                                    >
                                        <option value="">Select issue type</option>

                                        {issueTypes.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Description</label>

                                    <textarea
                                        rows="5"
                                        placeholder="Describe your issue..."
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="submit-btn"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Submitting..." : "Submit Issue"}
                                </button>
                            </form>
                        </div>

                        <div className="support-card">
                            <h3>Your Issues</h3>

                            {isLoadingIssues ? (
                                <p>Loading issues...</p>
                            ) : issues.length === 0 ? (
                                <p>No issues found.</p>
                            ) : (
                                <div className="issue-list">
                                    {issues.map((issue) => (
                                        <div className="issue-card" key={issue.id}>
                                            <div className="issue-card-header">
                                                <h4>{issue.ticketNumber || `Ticket #${issue.id}`}</h4>
                                                <span className="issue-status">
                                                    {issue.currentStatus || "open"}
                                                </span>
                                            </div>

                                            <p className="issue-type">
                                                {issue.issueType?.name || issue.type?.name || "N/A"}
                                            </p>

                                            <p className="issue-description">
                                                {issue.description}
                                            </p>

                                            <p className="issue-date">
                                                {issue.createdAt
                                                    ? new Date(issue.createdAt).toLocaleString()
                                                    : ""}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpAndSupport;